import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Professional, ProfessionalService, ProfessionalStyle } from '@adeo/ngx-kozikaza-api';
import { PresetUserAvatar } from '../../img-resize/image-resize.service';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsCertified } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-certified.icon';

@Component({
  selector: 'app-profile-preview-pro',
  templateUrl: './profile-preview-pro.component.html',
  styleUrls: ['./profile-preview-pro.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePreviewProComponent implements OnInit {

  @Input() professional: Professional;
  @Input() size: 'xs' |  'sm' | 'md' | 'lg' = 'lg';
  @Input() seeMore = true;
  @Input() seeMoreLink = true;
  @Input() linkToPro = false;
  @Input() limitStyles = 2;

  @HostBinding('class.profile-preview-pro') classes = true;
  @HostBinding('class.md') get sizeMd() {
    return this.size === 'md';
  };
  @HostBinding('class.sm') get sizeSm() {
    return this.size === 'sm';
  };
  @HostBinding('class.xs') get sizeXs() {
    return this.size === 'xs';
  };

  @Output() showMore: EventEmitter<any> = new EventEmitter<any>();

  public avatarPath: string;
  public presetUserAvatar: PresetUserAvatar;
  public imgSize = 102;

  constructor(
    private readonly _professionalService: ProfessionalService,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsCertified]);
  }

  ngOnInit() {
    if (this.sizeXs) {
      this.imgSize = 32;
    } else if (this.sizeSm) {
      this.imgSize = 56;
    } else if (this.sizeMd) {
      this.imgSize = 76;
    }
  }

  trackById(index: number, item: string | ProfessionalStyle): string {
    return (!item) ? null : (typeof item === 'string' ? item : item['@id']);
  }

}
